export const OTP_SEND_RESPONSE = 'OTP_SEND_RESPONSE';
export const OTP_VALIDATION_RESPONSE = 'OTP_VALIDATION_RESPONSE';
export const RESET_OTP_INFO_RESPONSE = 'RESET_OTP_INFO_RESPONSE';
export const VALIDATE_UNIQUE_MOBILE = 'VALIDATE_UNIQUE_MOBILE';
export const UPDATE_VALIDATED_FIELD_NAME = 'UPDATE_VALIDATED_FIELD_NAME';
export const RESET_OTP_V2_INFO_RESPONSE = 'RESET_OTP_V2_INFO_RESPONSE';
